import React, { useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Card, Table, Typography, Tabs, Tag, Pagination } from "antd";
import {
  ArrowLeftOutlined,
  InfoCircleOutlined,
  StopOutlined,
  SearchOutlined,
} from "@ant-design/icons";

const { Title} = Typography;

const { TabPane } = Tabs;

const sampleData = [
  {
    key: "1",
    name: "Rajesh Kumar",
    commodity: "Black Pepper",
    location: "Karnataka > Bangalore",
    count: 3,
  },
  {
    key: "2",
    name: "Priya Sharma",
    commodity: "Cumin Powder",
    location: "Gujarat > Ahmedabad",
    count: 5,
  },
  {
    key: "3",
    name: "Amit Singh",
    commodity: "Cardamom",
    location: "Maharashtra > Mumbai",
    count: 2,
  },
  {
    key: "4",
    name: "Neha Patel",
    commodity: "Chilli Powder",
    location: "Gujarat > Surat",
    count: 4,
  },
  {
    key: "5",
    name: "Suresh Kumar",
    commodity: "Turmeric Powder",
    location: "Tamil Nadu > Chennai",
    count: 1,
  },
];

const RegretCaseTrackingPage = ({ filters = {} }) => {
  const history = useHistory();
  const [selectedTab, setSelectedTab] = useState("notFound");

  const handleBackClick = useCallback(() => {
    history.push("/bo/dashboard");
  }, [history]);
  const columns = [
    {
      title: "Sampler Name",
      dataIndex: "name",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Commodity",
      dataIndex: "commodity",
    },
    {
      title: "State > District",
      dataIndex: "location",
    },
    {
      title: "Total Not Found",
      dataIndex: "count",
      align: "right",
      render: (text) => (
        <Tag color="blue" style={{ fontSize: 14, padding: "4px 10px" }}>
          {text}
        </Tag>
      ),
    },
  ];

  return (
    <Card
      style={{ marginTop: 24 }}
      bodyStyle={{ padding: 0, backgroundColor: "f9fafb" }} 
    >
      <Row align="middle" style={{ padding: "16px 24px" }}>
        <Col>
          <ArrowLeftOutlined
            style={{
              fontSize: 18,
              color: "#000",
              marginRight: 12,
              cursor: "pointer",
            }}
            onClick={handleBackClick}
          />
        </Col>
        <Col>
          <Title level={4} style={{ color: "#000", margin: 0 }}>
            Regret Case Tracking-Detailed View
          </Title>
        </Col>
      </Row>

      <div style={{ padding: 24, background: "#f9fafb", minHeight: "100vh" }}>

        {/* Tabs */}
        <Tabs
          defaultActiveKey="notFound"
          onChange={(key) => setSelectedTab(key)}
         
        >
          <TabPane
            tab={
              <span>
                <SearchOutlined /> Not Found Cases
              </span>
            }
            key="notFound"
          />
          <TabPane
            tab={
              <span>
                <InfoCircleOutlined /> Regret Cases
              </span>
            }
            key="regret"
          />
          <TabPane
            tab={
              <span>
                <StopOutlined /> Lab Rejections
              </span>
            }
            key="lab"
          />
        </Tabs>

        {/* Table header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Title
            level={5}
            style={{ display: "flex", alignItems: "center", gap: 8 }}
          >
            <SearchOutlined /> Not Found Cases
          </Title>
          <Tag color="blue" style={{ fontSize: 14, padding: "4px 10px" }}>
            Total: 15
          </Tag>
        </div>

        {/* Table */}
        <Card bodyStyle={{ padding: 0 }}>
          <Table
            dataSource={sampleData}
            columns={columns}
            pagination={false}
            rowKey="key"
            bordered={false}
          />
        </Card>

        {/* Pagination */}
        <div style={{ textAlign: "center", marginTop: 24 }}>
          <Pagination
            current={1}
            total={30}
            pageSize={10}
            showSizeChanger={false}
          />
        </div>
      </div>
    </Card>
  );
};

export default RegretCaseTrackingPage;
